export default __webpack_public_path__ + "static/media/invoke-url.946e1bc6.png";